import React from "react";
import { useDispatch } from "react-redux";
import verificationShield from "../../assets/images/verification-shield.svg";
import {
  closeMpinSetupPrompt,
  openSetMpinModal,
  openThanksPopup,
} from "../../features/slices/ModalSlice";

export default function MpinSetupPrompt() {
  const dispatch = useDispatch();

  const goToThanks = () => {
    dispatch(closeMpinSetupPrompt());
    dispatch(openThanksPopup());
  };

  const handleYes = () => {
    dispatch(closeMpinSetupPrompt());
    dispatch(openSetMpinModal());
  };

  return (
    <div
      className="modal fade otp--modal mpin-setup-prompt show"
      style={{
        display: "block",
        backdropFilter: "blur(15px)",
        background: "rgb(70, 70, 70, 0.6)",
      }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h2 className="modal-title fs-5" />
            <i
              data-bs-dismiss="modal"
              aria-label="Close"
              className="bi bi-x-lg"
              onClick={goToThanks}
            />
          </div>
          <div className="modal-body mpin-setup-prompt__body text-center">
            <img
              loading="lazy"
              src={verificationShield}
              alt="Verification success"
              width={72}
              height={72}
            />
            <p className="mpin-setup-prompt__subtitle">Verification Success!</p>
            <p className="mpin-setup-prompt__title">Wants to setup MPIN?</p>
            <div className="mpin-setup-prompt__actions">
              <button
                type="button"
                className="mpin-setup-prompt__no-btn"
                onClick={goToThanks}
              >
                No
              </button>
              <button
                type="button"
                className="mpin-setup-prompt__yes-btn"
                onClick={handleYes}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
